import React from 'react';
import PropTypes from 'prop-types';
import { Route } from 'react-router-dom';
import { getDisplayName } from 'recompose';

import { getInnerDisplayName } from './utils';
import withMetrics from './with-metrics';

export class MetricsRoute extends React.Component {
  componentDidMount() {
    this.setPageName();
  }

  componentDidUpdate(prevProps) {
    if (this.props.path !== prevProps.path) {
      this.setPageName();
    }
  }

  setPageName = () => {
    const { component, metrics, pageName } = this.props;
    const actualPageName = pageName || getInnerDisplayName(getDisplayName(component));

    if (actualPageName) {
      metrics.setPageName(actualPageName);
    }
  }

  render() {
    const { component: Component, metrics, pageName, render, ...rest } = this.props;

    if (!Component && !render) return null;

    const renderFn = render
      ? props => render({ ...props, metrics })
      : props => <Component {...props} metrics={metrics} />;

    return (
      <Route
        {...rest}
        render={renderFn}
      />
    );
  }
}

MetricsRoute.propTypes = {
  metrics: PropTypes.shape({
    setPageName: PropTypes.func.isRequired
  }).isRequired,
  path: PropTypes.string.isRequired,
  component: PropTypes.func,
  pageName: PropTypes.string,
  render: PropTypes.func
};

MetricsRoute.defaultProps = {
  component: undefined,
  render: undefined,
  pageName: ''
};

export default withMetrics(MetricsRoute);
